<template lang="pug">
  div
    v-tabs.tabs(:value="currentTab" background-color="#757575" color="#FFFFFF" slider-size="4" slider-color="#FFFFFF" height="42" dark centered grow)
      v-tab.text-none(v-for="(rootCat, index) in knowledgeCategory" :key="index" @click="setRootCat(index)") {{ rootCat.title }}

    v-tabs-items(:value="currentTab")
      v-tab-item(v-for="rootCat in knowledgeCategory" :key="rootCat.id")
        knowledgebase-explorer-path(v-for="childCat in rootCat.children" :key="childCat.id" :category="childCat" @click.native="setCategory(childCat)") {{ childCat.title }}
</template>

<script>
import { mapState, mapActions } from 'vuex'
import knowledgeBaseExplorerPath from "./KnowledgeBaseExplorerPath"

export default {
  name: 'knowledge-explorer',
  components: {
    [knowledgeBaseExplorerPath.name]: knowledgeBaseExplorerPath
  },

  computed: {
    ...mapState('knowledgeBase', ['knowledgeCategory'])
  },

  methods: {
    ...mapActions('knowledgeBase', ['setCategory']),
    setRootCat(idx){
      this.currentTab = idx
      this.setCategory(this.knowledgeCategory[idx] || null)
    }
  },

  data () {
    return {
      currentTab:0
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  border-bottom: 1px solid #FFFFFF;
  border-radius: 5px 5px 0px 0px;
}
</style>